import getAriaLabel from "./getAriaLabel";
import { useRef, useEffect } from "react";
import PropTypes from "prop-types";

const ProductLink = ({
  className,
  children,
  focusOnMount,
  anchorProductToUrl,
  href,
  isSponsored,
  analyticsProductClick,
  productTileId,
  sponsoredProps,
  pageNumber,
  ...rest
}) => {
  const anchorRef = useRef();

  useEffect(() => {
    if (focusOnMount) {
      if (anchorRef.current) {
        anchorRef.current.focus();
      }
    }
  }, []);

  const onClick = () => {
    anchorProductToUrl({ productTileId, pageNumber });
    if (isSponsored) {
      analyticsProductClick(sponsoredProps);
    }
  };

  return (
    <a
      ref={anchorRef}
      className={className}
      href={href}
      aria-label={getAriaLabel({
        isSponsored,
        ...rest
      })}
      onClick={onClick}
    >
      {children}
    </a>
  );
};

ProductLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isOutlet: PropTypes.bool,
  pageNumber: PropTypes.number,
  reducedPrice: PropTypes.string,
  productTileId: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  hasMultiplePrices: PropTypes.bool,
  description: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  anchorProductToUrl: PropTypes.func.isRequired,
  analyticsProductClick: PropTypes.func.isRequired,
  badgeType: PropTypes.oneOf(["MixMatch", "MoreColors"]),
  focusOnMount: PropTypes.bool.isRequired,
  isSponsored: PropTypes.bool.isRequired,
  sponsoredProps: PropTypes.object,
  discount: PropTypes.number,
  price: PropTypes.string.isRequired
};

export default ProductLink;
